import { chowbus_qr_code_ordering_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering.png`,
      title: 'QR Code Ordering',
      description: `Easy, quick contact-less ordering from the customer’s mobile device.`,
      youtubeVideoId: chowbus_qr_code_ordering_video_id.en,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering.png`,
      title: '二维码点餐系统，顾客自助点餐，无需设备投入 | 二维码菜单',
      description: '无需投入硬件设备，即可享受方便、快捷的无接触点单、支付体验',
      youtubeVideoId: chowbus_qr_code_ordering_video_id.zh,
    },
  },
  advances: {
    en: {
      title: `Chowbus QR Code Ordering is a one-stop ordering and payment solution 
      to help grow your business with efficiency and convenience`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_1.png`,
          imageAlt: 'Contactless Ordering Experience',
          title: 'Contactless Ordering Experience',
          description:
            'Empower your guests and your staff with an effective and efficient contactless ordering experience.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_2.png`,
          imageAlt: 'Serve more guests with fewer staff',
          title: 'Serve more guests with fewer staff',
          description:
            'Free up your staff’s time to handle other value-added tasks, such as building rapport with guests, which creates a more fulfilling dining experience for both guests and staff.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_3.png`,
          imageAlt: 'Collect Valuable Guest Data',
          title: 'Collect Valuable Guest Data',
          description:
            'Collect guest data on each transaction that can be leveraged to power your marketing and loyalty programs.',
        },
      ],
    },
    zh: {
      title: `Chowbus二维码菜单，集成了一站式订餐和支付系统，
      帮助您的餐厅提升工作效率，节约人力成本，升级顾客体验`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_1.png`,
          imageAlt: '无接触的点餐体验',
          title: '无接触的点餐体验',
          description: '顾客可以根据二维码菜单的图片、描述等自助下单，还可以随时加菜，提升点餐自由度',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_2.png`,
          imageAlt: '合理的时间分配',
          title: '合理的时间分配',
          description: '相比于低效地等待顾客点单，店员可以将时间投入到更有价值的服务上',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_feature_3.png`,
          imageAlt: '有效的产品组合',
          title: '有效的产品组合',
          description:
            '二维码菜单+会员系统，可以有效提升会员数和复购率；二维码菜单+手持POS，可以有效提升点单、支付效率',
        },
      ],
    },
  },

  features: {
    en: {
      title: 'Upgrade Your Restaurant',
      desc: `Chowbus is committed to provide the ultimate diner-driven experience, increase operational efficiency, and improve your restaurant margins.`,
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'A Better Way to Order',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_advance_1.png`,
          items: [
            {
              desc: 'Eliminate wait times and long lines by allowing guests to browser, order, and pay on their own!',
            },
            {
              desc: `Your QR code digital menu can be updated at no cost with just a few clicks! No printing costs required.`,
            },
            {
              desc: 'Setup your digital menu in multiple languages and make edits on the fly – even more savings on print materials.',
            },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'Faster Operations, More Profit',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_advance_2.png`,
          items: [
            {
              desc: 'Guests directly send their orders to the kitchen with no delay! Our average customer saves $8,000 month in labor per month.',
            },
            {
              desc: 'Increase your table turn rate by 25% with streamlined ordering and reducing redundant tasks for staff.',
            },
            { desc: `Digital menus allow for real-time menu item and price changes – 0 printing costs required!` },
            {
              desc: `QR code ordering often increases the average order size! Multiple diners order at the same time and diners can easily see who’s ordering what.`,
            },
          ],
        },
      ],
    },
    zh: {
      title: '升级您的餐厅体验',
      desc: 'Chowbus二维码菜单专为餐厅定制，能全面升级您的餐厅，大幅提升运营效率并降低人工成本',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '丝滑的点餐体验',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_advance_1.png`,
          items: [
            { desc: ' 顾客扫描二维码菜单自助浏览菜单并下单，还能随时加菜，提高客单价' },
            { desc: `多人同时扫码点单可以实时同步菜品，也避免因重复点菜等原因带来的客诉问题` },
            { desc: '清晰的菜品图和描述能有效帮助顾客了解菜品并吸引顾客下单' },
            { desc: '双语点餐界面能让中文母语者倍感亲切的同时，满足更多食客的点餐诉求' },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '高效的运营模式',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_qrcode_ordering_advance_2.png`,
          items: [
            {
              desc: '扫码下单的订单会自动发送至后厨，减少传递菜品信息的人力和时间成本',
            },
            {
              desc: '扫码点单产品精简店员的服务流程，有效减少月均$8,000的人力成本的同时，提升25%的翻台率',
            },
            { desc: '云端更新电子菜单，顾客即可扫码访问最新版菜单，节省纸质印刷费用' },
            { desc: '利用二维码菜单+会员系统，顾客可以注册会员、积累积分并兑换菜品，有效提升顾客黏性' },
          ],
        },
      ],
    },
  },
  whyNotChooseChowBus: {
    en: {
      title: 'Why Restaurants Choose Chowbus',
    },
    zh: {
      title: '他们选择Chowbus二维码菜单的原因',
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-shinyaramen_2.jpeg`,
      productLine: 'QR Code',
      desc: {
        zh: `通过使用无接触点餐, 深夜食堂的翻桌率提高了 30%, 并减少了三个人工. “我们的一些服务员担心, 通过使用二维码, 他们不会像以前那样得到那么多小费.” Shinya Ramen 的老板 Joey 告诉我们, “这种担忧很快就被打消了.
      我们的平均小费百分比提高了近35%, 因为服务员们现在可以专注于客人需要什么并且与客人建立友好关系.”`,
        en: `By adopting contactless QR code ordering, Shinya Ramen increased the table turnover rate by 30% and was able to cut two more headcounts. 
      “Some of our waiters and waitresses worry that by using QR code,  they would not get as much as tips as before. "Shinya Ramen's co-owner Joey told us,  
      “The concern was quickly dispelled. Our average tip percentage was increased almost 35% because waiters and waitresses can now focus on table  
      touching and making personal connections with the guests."`,
      },
      restaurantName: { zh: '深夜食堂', en: 'Shinya Ramen' },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/business-types/sushi-ramen/shinya-ramen-house',
    },
  ],
};

export default SectionContent;
